module.exports = __webpack_public_path__ + "img/img2.97c20170.jpg";